export default __webpack_public_path__ + "static/media/pintaria.27f9ea93.svg";